const advFormStyles = {
  '.container': { backgroundColor: '#ECEDEE' },
  '.formRow': { margin: '15px 0px 10px' },
  '.searchResults': {
    maxHeight: '185px',
    overflow: 'scroll',
    overflowX: 'hidden',
  },
  '.searchResult': {
    whiteSpace: 'pre-wrap !important',
    overflowWrap: 'break-word !important',
  },
  '.searchErrorMsg': { color: '#b42c01 !important' },
  '.searchLoading': {
    width: '100%',
    maxHeight: '0px',
    overflowY: 'visible',
    marginTop: '3px',
  },
  '.loading': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    width: '100%',
    minHeight: '120px',
    zIndex: 3,
    border: '1px solid #ecedee',
    borderRadius: '0.25rem',
  },
  '.fullWidth': { minWidth: '100%' },
  '.formBtnContainer': {
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 0px 30px 0px',
  },
};

export default advFormStyles;
